import ApiService from './ApiService'

/**
 * DeviceFlowService
 *
 * @class
 */
export default class DeviceFlowService {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * DeviceFlowService constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_AUTH_API)
    }

    /**
     * Activate user code
     *
     * @param {Object}  settings
     * @param {Object}  user
     * @param {Integer} userCode
     *
     * @returns {Promise}
     */
    activate({ company_uuid, cc, lang }, { access_token }, userCode) {
        return this.apiService
            .setAcceptLanguage(`${lang}-${cc}`)
            .setAccessToken(access_token)
            .post(`/${company_uuid}/devices/activate`, {
                user_code: userCode,
            })
    }

    activateCallback({ cc, lang }, { access_token }, callbackUrl) {
        return this.apiService
            .setAcceptLanguage(`${lang}-${cc}`)
            .setAccessToken(access_token)
            .get(callbackUrl)
    }

    /**
     * Check the status of the user code.
     *
     * @param {Object} settings
     * @param {String} verificationUri
     *
     * @returns {Promise}
     */
    status({ api_key }, verificationUri) {
        return this.apiService
            .setApiKey(api_key)
            .get(verificationUri)
    }
}
